export default "__VITE_ASSET__BMW2rv9v__"